import { render, staticRenderFns } from "./matchup_edit.vue?vue&type=template&id=19c73340&scoped=true&"
import script from "./matchup_edit.vue?vue&type=script&lang=js&"
export * from "./matchup_edit.vue?vue&type=script&lang=js&"
import style0 from "./matchup_edit.vue?vue&type=style&index=0&id=19c73340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c73340",
  null
  
)

export default component.exports